import { SkeletonView } from '@/design-system/components/cards';
import { View } from 'dripsy';

export const PageItemSkeleton: React.FC<{}> = () => {
  return (
    <View sx={{ gap: '$3' }}>
      <SkeletonView height={20} />
      <SkeletonView height={20} width={200} />
      <SkeletonView height={20} width={150} />
    </View>
  );
};
